import React, { useState } from 'react'
import { Form, Button, InputGroup } from "react-bootstrap"
import redirections from "../img/redirections.svg"
import ConfirmatoryModal from "../Components/ConfirmatoryModal";
import * as formik from 'formik';
import * as yup from 'yup';
import { saveRedirection, isValidPublicUrl, handleSubmit, handleChange, getModalData } from "../Functions/myfunctions";
import { useNavigate } from 'react-router-dom';


function NewRedirection() {

    const { Formik } = formik;
    const [errorMessage, setErrorMessage] = useState("");
    const [modalShow, setModalShow] = React.useState(false);
    const [actionName, setActionName] = useState({ name: '', action: '', values: '' });
    const [urlLink, setUrlLink] = useState();
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({
        serialNumber: "",
        publicUrl: "",
        privateUrl: "",
        partner: "",
        comment: "",
        active: 1, /* Alapértelmezetten aktívként hozzuk létre az átirányításokat. */
    })

    const NewRedirectionSchema = yup.object().shape({
        serialNumber: yup.string()
            .required('A gyáriszám kitöltése kötelező'),
        publicUrl: yup.string()
            .test("Az url valid", "Az url nem valid", (value) => {
                return isValidPublicUrl(value);
            })
            .required('A publikus url kitöltése kötelező'),
        privateUrl: yup.string()
            .url("Érvénytelen url")
            .required('A privát url kitöltése kötelező'),
        comment: yup.string()
            .max(100, 'A megjegyzés maximum 100 karakter hosszú lehet.')
    });


    const save = (values, actions) => {
        getModalData({ name: 'Kívánja az átirányítást létrehozni?', action: 'save', values: values }, "", modalShow, setActionName, setUrlLink, setModalShow);
    }

    const confirmationfunction = (event) => {
        event.preventDefault();
        actionName.values["UserId"] = sessionStorage.getItem("loggedUserId");
        actionName.values["SessionToken"] = sessionStorage.getItem("sessionToken");
        actionName.values["Active"] = 1;
        saveRedirection(actionName.values, setErrorMessage);
        setModalShow(false);
    }

    const navigate = useNavigate();

    const navigateToRedirections = () => {
        // 👇️ navigate to /redirections
        navigate('/redirections');
    };


    return (
        <div className="form-page-content">
            <div className='custom-title'><img src={redirections} alt="redirection icon" /><h1>Új Átirányítás</h1></div><br />
            <Formik initialValues={{
                serialNumber: "",
                publicUrl: process.env.REACT_APP_BASE_URL + "/api/redirect/",
                privateUrl: "",
                partner: "",
                comment: "",
            }}
                validationSchema={NewRedirectionSchema}
                onSubmit={(values, actions) => {
                    save(values, actions);
                }}
            >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="SerialNumber">
                            <Form.Label >
                                Gyári szám*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control placeholder="Gyári szám" type="text" name="serialNumber" required value={values.serialNumber} onChange={handleChange} isInvalid={!!errors.serialNumber} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.serialNumber}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="PublicUrl">
                            <Form.Label >
                                Publikus URL*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control placeholder="Publikus URL" type="text" name="publicUrl" required value={values.publicUrl} onChange={handleChange} isInvalid={!!errors.publicUrl} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.publicUrl}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="PrivateUrl">
                            <Form.Label >
                                Privát URL*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control placeholder="Privát URL" type="text" name="privateUrl" required value={values.privateUrl} onChange={handleChange} isInvalid={!!errors.privateUrl} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.privateUrl}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="Partner">
                            <Form.Label>
                                Partner
                            </Form.Label>
                            <InputGroup >
                                <Form.Control placeholder="Partner" type="text" name="partner" required value={values.partner} onChange={handleChange} />
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="Comment">
                            <Form.Label>Megjegyzés</Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control as="textarea" placeholder='Megjegyzés' name="comment" required value={values.comment} onChange={handleChange} isInvalid={!!errors.comment} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.comment}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3 form-buttons">
                            <Button type="submit" className="form-custom-button">Mentés</Button><Button onClick={navigateToRedirections} className='form-delete-button'>Mégsem</Button>
                        </Form.Group>
                        {errorMessage !== "" ? <p className="error mb-3">{errorMessage}</p> : ""}
                    </Form>
                )}
            </Formik>
            <ConfirmatoryModal actionname={actionName} urllink={urlLink} confirmationfunction={confirmationfunction}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    )
}

export default NewRedirection;